import { StyleConfig } from './types';

export const DEFAULT_STYLE_CONFIG: Required<StyleConfig> = {
    leftPane: {
        minWidth: '192px',
        width: 'max-content',
        padding: '0 10px 0 10px',
    },
    rightPane: {
        width: '200px',
        padding: '28px 10px 10px 10px',
    },
    menuItem: {
        width: '172px',
        height: '39px',
        fontSize: '14px',
        padding: '10px',
    },
    dropdown: {
        borderRadius: '10px',
        maxWidth: 'calc(100vw - 24px)',
    },
    footer: {
        padding: '10px 16px',
        gap: '10px',
    },
};

export const ANALYTICS_STYLE: StyleConfig = {
    leftPane: {
        minWidth: '192px',
    },
    rightPane: {
        width: '200px',
    },
};

export const FINANCE_STYLE: StyleConfig = {
    leftPane: {
        minWidth: '220px',
        padding: '0 15px 0 15px',
    },
    rightPane: {
        width: '240px',
        padding: '28px 15px 10px 15px',
    },
    menuItem: {
        width: '190px',
        height: '42px',
        fontSize: '15px',
    },
};